import React, { Component } from "react";

import {
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  WhatsappIcon,
  TwitterShareButton,
  EmailIcon,
  TwitterIcon,
  WhatsappShareButton,
} from "react-share";
import copy from "copy-to-clipboard";
import Image from "../../Image";
export default class ShareCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: false,
    };
  }
  copyLink = () => {
    const { title, url } = this.props;
    copy(url);
    alert(`${title} copied to clipboard`);
  };
  render() {
    const { title, url } = this.props;
    return (
      <>
        <div className="nps-link-generate">
          <div className="nps-link-generate-header">
            <h5 className="nps-link-generate-head">{title}</h5>
          </div>
          <div
            className="nps-link-generate-body"
            onMouseLeave={() => this.setState({ display: false })}
          >
            <div className="nps-link mouse-pointer" onClick={this.copyLink}>
              <span
                style={{
                  textDecoration: "underline",
                  color: "rgb(25, 75, 126)",
                  fontFamily: "OpenSans-SemiBold",
                  fontSize: "14px",
                  wordBreak: "break-all  ",
                }}
              >
                {url}
              </span>
            </div>
            <span className="nps-share-copy">
              <Image
                src={"/images/dit_share.svg"}
                alt="share"
                style={{
                  height: 25,
                  marginLeft: 10,
                  marginTop: 7.5,
                  cursor: "pointer",
                }}
                onMouseEnter={() => this.setState({ display: true })}
                onTouchStart={() =>
                  this.setState({ display: !this.state.display })
                }
              />
              <Image
                onClick={this.copyLink}
                src={"/images/dit_copy.svg"}
                alt="copy"
                style={{
                  height: 25,
                  marginLeft: 10,
                  marginTop: 7.5,
                  cursor: "pointer",
                }}
              />

              <div
                className="nps-share"
                style={{
                  display: this.state.display ? "flex" : "none",
                }}
              >
                <FacebookShareButton
                  url={url}
                  quote={"Checkout the NPS Onboarding Link"}
                >
                  <FacebookIcon size={32} round={true} />
                </FacebookShareButton>

                <WhatsappShareButton
                  url={url}
                  quote={"Checkout the NPS Onboarding Link"}
                >
                  <WhatsappIcon size={32} round={true} />
                </WhatsappShareButton>

                <EmailShareButton
                  subject={`NPS Onboarding URL`}
                  body={`Check out the Link : ${url}`}
                >
                  <EmailIcon size={32} round={true} />
                </EmailShareButton>

                <TwitterShareButton
                  url={url}
                  quote={"Checkout the NPS Onboarding Link"}
                >
                  <TwitterIcon size={32} round={true} />
                </TwitterShareButton>
              </div>
            </span>
          </div>
        </div>
      </>
    );
  }
}
